/** @license See the LICENSE file. */
// This code is auto-generated, do not modify this file!
const version = '3.14.0';
export { version };
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tensorflow/tfjs-backend-wasm/dist/version.js
// module id = null
// module chunks = 